<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="ack"><div class="chapterHead"><h2 class="chapterTitle1"><span class="bold"><span><em class="italic"><span>Acknowledgments</span></em></span></span></h2></div><div class="chapterBody">
<p class="paraNoIndent"><span>I would like to acknowledge my agent, Karen Solem, who never says, “You want to write WHAT?”</span></p>
<p class="para"><span>And a huge hug to my new editor, Micki Nuding, who was also my old editor from a long time ago. Micki, you were right! We’re working together again! WOOHOO!</span></p></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416538318_ack.vue?5a32d324